<template>
  <div>
    <div class="con-head">
      <div><img style="height: 100%;position: absolute" src="../assets/head-logo.png"/></div>
      <div class="con-btn" @click="showDialog()">高校申请试用</div>
    </div>
    <van-dialog
      v-model="show"
      :show-confirm-button="false"
    >
      <div style="font-size: 20px;color: #005CE5;font-weight: bold;margin: 30px 0 0 0;">高校申请试用</div>
      <br>
        <img style="width: 30%;height: 30%;margin-bottom: 20px;" src="./computer.png" alt="image" /><br>
      <div style="margin-bottom: 8px">请访问pc端www.gocheck.cn</div>
      <div>进行申请</div>
      <br>
      <van-button @click="show = false" style="width: 140px;height: 40px;border-radius: 20px;margin: 10px;background: #005CE5;margin-bottom: 30px;" type="info">知道了</van-button>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from 'vant';
export default {
  name: "headMenu",
  data(){
    return{
      conShow:true,
      show:false,
      message:'./computer.png',
    }
  },
  mounted() {

  },
  methods:{
    showDialog(){
      this.show = true
      // Dialog.alert({
      //   title:'高校申请试用',
      //   message: '<img src="./computer.png"/><br>请登录pc端www.gocheck.cn 进行申请',
      //   theme: 'round-button',
      //   confirmButtonText:'知道了',
      //   confirmButtonColor:'#005CE5'
      // }).then(() => {
      //   // on close
      // });
    },
    //
    schoolApply(){
      this.$emit('showApply')
    },
  }
}
</script>


<style scoped>
  .con-head{
      position: fixed;
      height: 64px;
      background: #005CE5;
      margin: auto;
      left: 0;
      top: 0;
      right: 0;
      display: flex;
      z-index: 9999;
  }
  .con-btn{
      width: 110px;
      height: 28px;
      font-size: 14px;
      background: #FFFFFF;
      border-radius: 28px;
      color: #DC4900;
      line-height: 28px;
      position: absolute;
      margin: auto;
      top: 18px;
      right: 10px;
  }
</style>